import * as yup from "yup";

export const validationSchema = yup.object({
  // TODO: Add this part of the schema back in when we reenable email changing
  // email: yup.string().required().email(),
  username: yup.string().required().min(3)
});
